import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function DogIdentifierTerms() {
  return (
    <div style={{ backgroundColor: '#0f0f0f', minHeight: '100vh', color: '#fff', padding: '60px 0' }}>
      <Container>
        <Row>
          <Col md={8} className="mx-auto">
            <div style={{ marginBottom: 32 }}>
              <Link to="/dog-identifier" style={{ color: '#E8855A', textDecoration: 'none', fontSize: 14 }}>
                ← Back to Dog Identifier
              </Link>
            </div>

            <h1 style={{ fontWeight: 800, marginBottom: 8 }}>Terms &amp; Conditions</h1>
            <p style={{ color: '#E8855A', fontWeight: 600, marginBottom: 4 }}>Dog Identifier – Breed Scanner</p>
            <p style={{ color: '#666', fontSize: 13, marginBottom: 40 }}>Last updated: April 8, 2026</p>

            <div style={{ lineHeight: 1.8, color: '#ccc' }}>

              <p>
                By downloading or using the <strong>Dog Identifier – Breed Scanner</strong> app,
                these terms will automatically apply to you. Please read them carefully before using the app.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Use of the App</h3>
              <p>
                Dog Identifier is provided by Westron for personal, non-commercial use. You agree not to:
              </p>
              <ul>
                <li>Copy, modify, or distribute the app or any part of it</li>
                <li>Attempt to extract the source code or reverse-engineer the app</li>
                <li>Use the app for any unlawful or harmful purpose</li>
                <li>Interfere with or disrupt the app's servers or networks</li>
              </ul>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>AI Accuracy</h3>
              <p>
                Dog Identifier uses AI models to identify dog breeds. While we strive for accuracy,
                breed identification results are provided for informational purposes only and may not
                always be correct. Do not rely solely on the app's output for medical, breeding, or
                legal decisions.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Intellectual Property</h3>
              <p>
                All content within the app — including breed information, images, and the AI model —
                is the property of Westron or its licensors and is protected by applicable intellectual
                property laws.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Accounts</h3>
              <p>
                You may sign in using Google or Apple. You are responsible for maintaining the
                confidentiality of your account and for all activities that occur under it. Westron
                reserves the right to suspend or terminate accounts that violate these terms.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Advertisements</h3>
              <p>
                The free version of Dog Identifier is supported by advertising served by Google AdMob.
                We are not responsible for the content of third-party ads. Clicking an ad takes you
                outside of our app; we have no control over third-party sites or services.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Disclaimer of Warranties</h3>
              <p>
                The app is provided "as is" without warranty of any kind, express or implied.
                Westron does not warrant that the app will be error-free, uninterrupted, or free
                of viruses or other harmful components.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Limitation of Liability</h3>
              <p>
                To the maximum extent permitted by law, Westron shall not be liable for any indirect,
                incidental, special, consequential, or punitive damages arising from your use of the app.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Changes to These Terms</h3>
              <p>
                We may update these terms from time to time. Continued use of the app after changes
                are posted constitutes acceptance of the new terms.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Governing Law</h3>
              <p>
                These terms are governed by the laws of India. Any disputes shall be subject to the
                exclusive jurisdiction of the courts of India.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Contact Us</h3>
              <p>
                For questions about these terms, contact us at{' '}
                <a href="mailto:legal@westron.dev" style={{ color: '#E8855A' }}>legal@westron.dev</a>.
              </p>
            </div>

            <div style={{ marginTop: 48, paddingTop: 24, borderTop: '1px solid #222', display: 'flex', gap: 16, flexWrap: 'wrap' }}>
              <Link to="/dog-identifier" style={{ color: '#E8855A', textDecoration: 'none', fontSize: 14 }}>Dog Identifier</Link>
              <Link to="/dog-identifier/privacy-policy" style={{ color: '#E8855A', textDecoration: 'none', fontSize: 14 }}>Privacy Policy</Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DogIdentifierTerms;
